import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueSocketIO from 'vue-socket.io';
import io from 'socket.io-client';
import Toasted from 'vue-toasted';
Vue.use(Toasted)

import {
  VTooltip
} from 'v-tooltip'
Vue.directive('tooltip', VTooltip)

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import filters from './filters';
for (let name in filters) {
  Vue.filter(name, filters[name]);
}

//graficos
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

//exportar json a excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

Vue.use(require('vue-moment'));

Vue.config.productionTip = false

const token = localStorage.getItem('token')
if (token) {
  store.state.api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

const SocketInstance = io.connect(process.env.VUE_APP_SOCKET);
Vue.use(new VueSocketIO({
  debug: false,
  connection: SocketInstance,
  vuex: {
    store,
    mutationPrefix: 'SOCKET_'
  },
}));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')